import {Component, inject} from '@angular/core';
import {BehaviorSubject, catchError, map, Observable, of, tap} from "rxjs";
import Swal from "sweetalert2";
import { TranslateService} from "@ngx-translate/core";
import {UserNotificationService} from "../../sevices/user-notification.service";

@Component({
  selector: 'lcms-toggle-notif',
  templateUrl: './toggle-notif.component.html',

  styleUrls: ['./toggle-notif.component.scss'],
})
export class ToggleNotifComponent {
  translateService = inject(TranslateService)
  notifService = inject(UserNotificationService)
  alertSub = new BehaviorSubject<any>(null)


  // alerts: Array<AlertModel> = defaultAlerts;
  alerts$ : Observable<any> = this.notifService.getUserNotif().pipe(
    catchError((err) => of({
      data: []
    })),
    map(dt => dt.data.filter((item: any) => item.type === 'PUSHER')
      .sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())),
    tap((alerts: any[]) => {
      this.alertSub.next(alerts);
      this.notifService.notifSub.next(alerts);
    })
  );

  readNotif(notif  :any , alertss : any){
    const  notifService ={
      notifications :[notif]
    }
    alertss =alertss.filter((alert :any) => alert.id !== notif)
    this.alerts$=of(alertss)
    this.alertSub.next(alertss) ;
    this.notifService.notifSub.next(alertss);
    this.notifService.readNotif(notifService).subscribe({
      next: (response :any) => {
        if (response instanceof Error) {
          Swal.fire(
            this.translateService.instant("modal.failure" ?? 'Ooooops...') ,
            this.translateService.instant(response?.message ?? "modal.error_msg"),
            'error'
          );
          throw response;

        }
        // const Toast = Swal.mixin({
        //   toast: true,
        //   position: 'top-left',
        //   timer: 2500,
        //   timerProgressBar: true,
        //   showConfirmButton: false,
        // })
        // Toast.fire(this.translateService.instant("modal.requested_msg"), '', 'success')
      },
      error: (error :any) => {

        Swal.fire({
          title: this.translateService.instant("modal.failure" ?? 'Ooooops...') ,
          html: error.error.message,
          icon: 'error',
          allowOutsideClick: false
        });
      },
      complete: () => console.log('completed'),
    })
  }

}

